module.exports = __webpack_public_path__ + "img/707.94598d57.jpg";